import MyTeamPlans from "./MyTeamPlan";

export default MyTeamPlans;
